import { daggerBadge } from "../../icons"
import "./spinning-logo.component.css"

const SpinningLogoComponent = () => {
  return <div className="dagger-spinning-logo">{daggerBadge}</div>
}

export default SpinningLogoComponent
